var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card hover-zoom hover-shadow"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"d-flex media"},[_c('div',{staticClass:"media-body"},[_c('h3',[_vm._v(" "+_vm._s(_vm.stat)+" ")]),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.label))])]),_c('div',{staticClass:"align-self-center"},[_vm._t("svg")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }